module.exports = __webpack_public_path__ + "img/info-04.3c8584a3.jpg";